import { NEW_API_ROUTE_ADMIN_DRILL_DOWN_DEPARTMENT_COST_OBJECTS_PRODUCTS } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { DrillDownParamsOriginal, EntityOriginal, ListResponse } from './types'

import type { ReportEntityWithQuantity } from '../../drilldown/types'

type ProductReport = ReportEntityWithQuantity & {
  productCategoryId: number
  productCategoryName: string
  productGroupId: number
  productGroupName: string
}

type DDProductByDepartmentAndCostObjectResponse = ListResponse<ProductReport> & {
  department: EntityOriginal
  costObject: EntityOriginal
}

const IS_NEW_BACKEND_API = true

export const getDrillDownProductsByDepartmentsAndCostObject = async (
  params: DrillDownParamsOriginal
) => {
  const query = new URLSearchParams({ ...params })

  const categoryResult = await get<DDProductByDepartmentAndCostObjectResponse>(
    `${NEW_API_ROUTE_ADMIN_DRILL_DOWN_DEPARTMENT_COST_OBJECTS_PRODUCTS}?${query.toString()}`,
    IS_NEW_BACKEND_API
  )

  return {
    ...categoryResult,
    rows: categoryResult.rows.map(category => ({
      ...category,
      amount: Number(category.amount),
      salaryDeductionAmount: Number(category.salaryDeductionAmount),
    })),
  }
}
